export const RETURN_STATUSES = {
  PENDING: 'pending',
  RECEIVED: 'received',
  CANCELLED: 'cancelled',
};

export const RETURNS_PER_PAGE = 10;

export const MIN_RETURN_QUANTITY = 0.001;

export const RETURN_TEXTS = {
  date: 'Fecha',
  costPending: 'Costo pendiente de valoración',
  legacyOrigin: 'Origen documentado por evidencia',
  searchItems: 'Buscar material o entrega',
  loadError: 'No se pudieron consultar las devoluciones',
  tabConsumptions: 'Consumos',
  tabReturns: 'Devoluciones de obra',
  title: 'Devolución de materiales de obra',
  create: 'Autorizar devolución',
  receive: 'Recibir devolución',
  project: 'Obra de origen',
  warehouse: 'Depósito receptor',
  responsible: 'Responsable',
  reason: 'Motivo',
  source: 'Entrega de origen',
  legacy: 'Material sin entrega en el sistema',
  evidence: 'Evidencia del origen',
  article: 'Material',
  searchArticle: 'Buscar material',
  add: 'Agregar material',
  quantity: 'Cantidad',
  limit: 'Máximo',
  accepted: 'Aceptado',
  pending: 'Pendiente de recepción',
  received: 'Recibida',
  cancelled: 'Anulada',
  status: 'Estado',
  search: 'Buscar devolución',
  all: 'Todos',
  clear: 'Limpiar filtros',
  view: 'Ver devolución',
  remove: 'Quitar material',
  cancel: 'Cancelar',
  close: 'Cerrar',
  save: 'Autorizar',
  confirm: 'Confirmar recepción',
  empty: 'No hay devoluciones de obra',
  noItems: 'Agregá los materiales a devolver',
  documents: 'Materiales',
  noMatchingItems: 'No hay materiales que coincidan con la búsqueda',
  origin: 'Origen de los materiales',
  data: 'Datos de devolución',
  sections: 'Devolución de obra',
  materials: 'Materiales',
  next: 'Revisar materiales',
  error: 'No se pudo guardar la devolución',
  loading: 'Cargando devoluciones…',
  info:
    'Autorizar no modifica stock. Al recibir, los sobrantes aceptados quedan libres en depósito ' +
    'con su costo de origen o pendientes de valoración.',
  cancelReturn: 'Anular devolución',
  cancelTitle: 'Anular devolución de obra',
  cancelConfirm: 'Anular',
  cancelError: 'No se pudo anular la devolución',
  cancelMessage: (row) =>
    `¿Confirmás anular la devolución de "${row?.project_label || ''}"? ` +
    'No se modifica el stock y el saldo autorizado vuelve a quedar disponible.',
  statuses: [
    { value: '', label: 'Todos' },
    { value: RETURN_STATUSES.PENDING, label: 'Pendiente de recepción' },
    { value: RETURN_STATUSES.RECEIVED, label: 'Recibida' },
    { value: RETURN_STATUSES.CANCELLED, label: 'Anulada' },
  ],
};

export const RETURN_STATUS_CONFIG = {
  [RETURN_STATUSES.PENDING]: { label: RETURN_TEXTS.pending, color: 'warning' },
  [RETURN_STATUSES.RECEIVED]: { label: RETURN_TEXTS.received, color: 'success' },
  [RETURN_STATUSES.CANCELLED]: { label: RETURN_TEXTS.cancelled, color: 'default' },
};

export const INITIAL_RETURN_FORM = {
  uuid_project: '',
  uuid_warehouse: '',
  responsible: '',
  reason: '',
  items: [],
  legacy: false,
  legacy_evidence: '',
};

export const RETURN_DRAWER_SECTIONS = [
  { id: 'data', label: RETURN_TEXTS.data },
  { id: 'materials', label: RETURN_TEXTS.materials },
];

export const RETURN_ACTION_SX = {
  height: 56,
  flexShrink: 0,
  whiteSpace: 'nowrap',
};

export const RETURN_FILTER_SX = { flex: '1 1 200px', minWidth: 0, mt: 0 };

export const RETURN_TABLE_LAYOUT = { minWidth: 1160, date: 190, status: 220, actions: 90 };

const RETURN_TABLE_FIXED_WIDTH =
  RETURN_TABLE_LAYOUT.date + RETURN_TABLE_LAYOUT.status + RETURN_TABLE_LAYOUT.actions;
const RETURN_TABLE_TEXT_WIDTH = `calc((100% - ${RETURN_TABLE_FIXED_WIDTH}px) / 3)`;

export const RETURN_TABLE_COLUMNS = [
  { key: 'created_at', label: RETURN_TEXTS.date, width: RETURN_TABLE_LAYOUT.date },
  {
    key: 'project_label',
    label: RETURN_TEXTS.project,
    width: RETURN_TABLE_TEXT_WIDTH,
    wrap: true,
  },
  {
    key: 'warehouse_name',
    label: RETURN_TEXTS.warehouse,
    width: RETURN_TABLE_TEXT_WIDTH,
    wrap: true,
  },
  { key: 'responsible', label: RETURN_TEXTS.responsible, wrap: true },
  { key: 'status', label: RETURN_TEXTS.status, width: RETURN_TABLE_LAYOUT.status, align: 'center' },
];
